module.exports = __webpack_public_path__ + "img/pic2.a24bd531.png";